import {
  HttpClient,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urlsNotification } from 'src/app/helpers/urls';
import { NotificationBaseDto } from 'src/app/models/notification/notification-base-dto';
import { NotificationModuleType } from 'src/app/models/notification/notification-module-type';
import { NotificationStatisticsDto } from 'src/app/models/notification/notification-statistics-dto';
import {
  UpdateNotificationMarkAllAsReadDto,
  UpdateNotificationMarkItemsAsReadDto
} from 'src/app/models/notification/update-notification-base-dto';
import { UpdateNotificationPayloadBaseDto } from 'src/app/models/notification/update-notification-payload-dto';
import { CommonService } from '../../common.service';

dayjs.extend(utc);

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private http = inject(HttpClient);
  private commonService = inject(CommonService);

  private useMock: boolean = false;

  getStatistics$(
    startingFrom: Dayjs = null
  ): Observable<NotificationStatisticsDto> {
    let params = new HttpParams();

    if (startingFrom != null) {
      params = params.set('startingFrom', startingFrom.utc().toISOString());
    }

    return this.http
      .get<NotificationStatisticsDto>(
        `${urlsNotification.notificationStatistics}`,
        { params: params }
      )
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  getNotifications$(
    type: NotificationModuleType,
    startingFrom: Dayjs
  ): Observable<NotificationBaseDto[]> {
    let params = new HttpParams();
    params = params.set('startingFrom', startingFrom.utc().toISOString());
    params = params.set('type', type);

    return this.http
      .get<
        NotificationBaseDto[]
      >(`${urlsNotification.notifications}`, { params: params })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  markAllAsRead$(type: NotificationModuleType): Observable<boolean> {
    let params = new HttpParams();
    params = params.set('type', type);

    const payload = new UpdateNotificationMarkAllAsReadDto();

    return this.http
      .put<boolean>(`${urlsNotification.notifications}`, payload, {
        params: params
      })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  markItemsAsRead$(
    type: NotificationModuleType,
    notificationIds: string[]
  ): Observable<boolean> {
    let params = new HttpParams();
    params = params.set('type', type);

    const payload = new UpdateNotificationMarkItemsAsReadDto();
    payload.notificationIds = notificationIds;

    return this.http
      .put<boolean>(`${urlsNotification.notifications}`, payload, {
        params: params
      })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  update$(payload: UpdateNotificationPayloadBaseDto): Observable<boolean> {
    return this.http
      .put<boolean>(`${urlsNotification.notifications}`, payload)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  delete$(
    notificationIds: string[],
    type: NotificationModuleType
  ): Observable<void> {
    let params = new HttpParams();
    params = params.set('ids', notificationIds.join(','));
    params = params.set('type', type);

    return this.http
      .delete<void>(`${urlsNotification.notifications}`, { params: params })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  private mockStatistics(): NotificationStatisticsDto {
    const result = new NotificationStatisticsDto();
    result.total = 10;
    result.totalUnread = 5;
    result.slices = [
      {
        module: NotificationModuleType.WorkItem,
        total: result.total,
        totalUnread: result.totalUnread
      }
    ];
    return result;
  }

  // private mockNotifications(): NotificationDto[] {
  //   const result: NotificationDto[] = [];
  //   const workItemIds = [3792480,3798111,3804572,3809108,3794380,3799442,3805881,3792599,3798209,3804605,3809197,3790680,3792861,3796460,3798320,3803064,3804762,3807686,3809383, 1854959];

  //   for (let index = 0; index < 123; index++) {
  //     const workItemId = workItemIds[index % (workItemIds.length - 1)];
  //     const notification = new NotificationDto();
  //     notification.id = `${index}`;
  //     notification.title = `Title - ${index}`;
  //     notification.message = `Message - ${index}`;
  //     notification.createdTime = dayjs();
  //     notification.read = index % 4 == 0;
  //     notification.module = NotificationModuleType.WorkItem;
  //     notification.workItemId = workItemId;
  //     result.push(notification);
  //   }

  //   return result;
  // }
}
